import React from 'react';
import { connect } from 'react-redux';
import dataModel from '../../models/DataModel';
import Microphone from '../../components/Iconoclast/Microphone';
import LoadingDots from '../../components/LoadingDots';
import handsFreeAnnouncement from '../../assets/audio/Hands free mode - Tilt.mp3';
import listeningToneFile from '../../assets/audio/goodbeep.wav';
import confirmToneFile from '../../assets/audio/confirmbeep.wav';

import './HandsFreeButton.scss';

export class HandsFreeButton extends React.Component {
  constructor(props) {
    super(props);
    this.toggleHandsFree = this.toggleHandsFree.bind(this);
    this.motionDetected = this.motionDetected.bind(this);
    this.speechDetected = this.speechDetected.bind(this);
    this.turnOffAnnouncement = this.turnOffAnnouncement.bind(this);
    this.handleDetection = this.handleDetection.bind(this);

    const handsFreeEnabled = dataModel.getHandsFreeFlag();

    this.state = {
      handsFreeEnabled: handsFreeEnabled,
      listeningEnabled: false,
      playHandsFreeAnnouncement: false,
    };

    dataModel.mobileBridge.addMotionObserver(this.motionDetected);
    dataModel.mobileBridge.addSpeechDetectedObserver(this.speechDetected);
    if (handsFreeEnabled) {
      dataModel.mobileBridge.startMotionDetection();
    }
  }

  componentWillUnmount() {
    dataModel.mobileBridge.removeMotionObserver(this.motionDetected);
    dataModel.mobileBridge.removeSpeechDetectedObserver(this.speechDetected);
  }

  toggleHandsFree() {
    this.setState({ 
      handsFreeEnabled: !this.state.handsFreeEnabled,
      playHandsFreeAnnouncement: !this.state.handsFreeEnabled, //this is only turned on when hands free is enabled so it's controlled by that element
    });

    //if turning hands free off, don't need to delay stopping detetion
    if (this.state.handsFreeEnabled) {
      this.handleDetection(false);
      dataModel.setHandsFreeFlag(false);
    }
    else {
      dataModel.setHandsFreeFlag(true);
    }
  }

  handleDetection(startDetection=true) {
    const { listeningEnabled } = this.state;
    if (!listeningEnabled) {
      if (startDetection) {
        dataModel.mobileBridge.startMotionDetection();
      }
      else {
        dataModel.mobileBridge.stopMotionDetection();
      }
    }
    this.turnOffAnnouncement();
  }

  turnOffAnnouncement() {
    if (this.state.playHandsFreeAnnouncement) this.setState({ playHandsFreeAnnouncement: false });
  }

  motionDetected(results) {
    const { listeningEnabled } = this.state;
    if (results.count >= 1 && !listeningEnabled) {
      const listeningTone = new Audio(listeningToneFile);
      listeningTone.play();
      // NOTE: this tone will not play consistently... may be affected
      // by the css animation triggered by the set state?... regardless
      // we wait for the tone to complete before starting animation
      // and speech detection?
      listeningTone.addEventListener('ended', (event) => {
        dataModel.mobileBridge.detectSpeech();
        this.setState({
          listeningEnabled: true,
        });
      });
    }
  }

  speechDetected(results) {
    const confirmTone = new Audio(confirmToneFile);
    confirmTone.play();
    this.setState({
      listeningEnabled: false,
    });
  }

  render() {
    const { 
      handsFreeEnabled, 
      listeningEnabled, 
      playHandsFreeAnnouncement,
    } = this.state;

    const { currentCompany } = this.props;
    
    //return nothing if hands free feature not turned on
    // NOTE: device plugin is currently configured for ios but not android
    // and since we only support hands free on iOS hence the strange check
    // below
    if (!(window.device && window.device.platform == 'iOS' && currentCompany && currentCompany.features && currentCompany.features.hands_free && currentCompany.features.hands_free.enabled)) {
      return null;
    }

    let handsFreeAnnouncementPlayer = null;
    if (playHandsFreeAnnouncement) {
      handsFreeAnnouncementPlayer = <audio src={handsFreeAnnouncement} autoPlay onEnded={this.handleDetection} />;
    }

    return (
      <button 
        className={'hands-free hands-free' + (listeningEnabled ? '--listening' : (handsFreeEnabled ? '--active' : '--inactive'))} 
        onClick={this.toggleHandsFree}
      >
        <Microphone 
          fillColor={(handsFreeEnabled || listeningEnabled) ? '#ffffff' : null}
        />
        {
          (handsFreeEnabled && !listeningEnabled) && <p>HANDS FREE</p>
        }
        {
          (listeningEnabled) && <p>LISTENING</p>
        }
        {
          (listeningEnabled) && <LoadingDots
                                  color='#ffffff'
                                />
        }
        { handsFreeAnnouncementPlayer }
      </button>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(HandsFreeButton);



// WEBPACK FOOTER //
// ./src/components/HandsFreeButton/index.js